import { Component } from "react";

/**
 * AdsumErrorBoundary
 * Defensive boundary around the Adsum (Agent 3) card so any unexpected
 * render-time error inside Adsum does NOT take down the entire schedule
 * panel. Adsum uses plain HTTP (axios) for all I/O and does not depend on
 * any WebSocket state — this boundary is pure render safety.
 */
export default class AdsumErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorMessage: null };
    }

    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            errorMessage: error?.message || "Adsum could not render.",
        };
    }

    componentDidCatch(error, info) {
        console.error("[AdsumErrorBoundary]", error, info?.componentStack);
    }

    reset = () => {
        this.setState({ hasError: false, errorMessage: null });
    };

    render() {
        if (!this.state.hasError) return this.props.children;
        return (
            <div
                className="flex flex-col gap-3 rounded-2xl border border-[#FF5470]/30 bg-[#111726] p-6"
                data-testid="adsum-error-boundary"
            >
                <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-[#FF5470]">
                    agent 3 · adsum unavailable
                </span>
                <p className="text-sm text-[#E8ECF5]">
                    Adsum hit a render error and was isolated so the rest of the
                    schedule panel keeps working.
                </p>
                <p className="font-mono text-xs text-[#8A93A6]">
                    {this.state.errorMessage}
                </p>
                <button
                    type="button"
                    onClick={this.reset}
                    className="self-start rounded-md border border-[#1F2A40] px-3 py-1.5 text-xs text-[#8A93A6] transition-colors hover:border-[#00F5D4]/40 hover:text-[#00F5D4]"
                    data-testid="adsum-error-boundary-retry"
                >
                    Retry
                </button>
            </div>
        );
    }
}
